import userDropdown from '@/components/app/header/user-dropdown/user-dropdown.vue'
import router from '@/router'
import store from '@/store'
import { mapActions, mapMutations } from 'vuex'

export default {
  components: {
    userDropdown
  },
  props: {
    redirectPageOnCreateNew: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menuItems: [
        {
          name: 'My Active Campaigns',
          href: 'dashboard',
          visible: true,
          action: ''
        },
        {
          name: 'My Draft Campaigns',
          href: 'dashboard-draft',
          visible: true,
          action: ''
        },
        {
          name: 'My Campaign Vault',
          href: 'dashboard-archived',
          visible: true,
          action: ''
        },
        {
          name: 'Competitions Overview',
          href: 'competitions-overview',
          visible: this.isAdmin(),
          action: ''
        },
        {
          name: 'User Management',
          href: 'user-management',
          visible: this.isAdmin(),
          action: ''
        },
        {
          name: 'Settings',
          href: 'attributes',
          visible: this.isAdmin(),
          action: function () {
            return this.setActiveTab('attributes')
          }.bind(this)
        }
      ],
      buttonInHeader: {},
      searchedText: ''
    }
  },
  watch: {
    $route: function (page) {
      this.setButtonAndSearch(page)
    }
  },
  computed: {
    visibleMenuItems() {
      return this.menuItems.filter((item) => item.visible)
    }
  },
  methods: {
    ...mapActions('competition', ['getCompetitions', 'setSearchedText']),
    ...mapMutations('settings', ['setActiveTab']),
    setButtonAndSearch: function (page) {
      this.setSearchedText('')
      switch (page.name) {
        case 'user-profile':
          this.buttonInHeader = {
            isVisible: false,
            redirect: ''
          }
          this.isSearchVisible = false
          break
        case 'dashboard':
          this.buttonInHeader = {
            isVisible: true,
            redirect: 'page-templates',
            title: 'Competition'
          }
          this.isSearchVisible = true
          break
        case 'dashboard-draft':
          this.buttonInHeader = {
            isVisible: true,
            redirect: 'page-templates',
            title: 'Competition'
          }
          this.isSearchVisible = true
          break
        case 'dashboard-archived':
          this.buttonInHeader = {
            isVisible: true,
            redirect: 'page-templates',
            title: 'Competition'
          }
          this.isSearchVisible = true
          break
        case 'user-management':
          this.buttonInHeader = {
            isVisible: true,
            redirect: 'user-add',
            title: 'User'
          }
          this.isSearchVisible = false
          break
        default:
          this.buttonInHeader = {
            isVisible: false,
            redirect: ''
          }
          this.isSearchVisible = false
          break
      }
    },
    isAdmin: function () {
      return store.getters['user/isAdmin']
    },
    isSuperAdmin: function () {
      return store.getters['user/isSuperAdmin']
    },
    search: function (event) {
      if (event.keyCode === 13) {
        this.setSearchedText({ searchedText: this.searchedText })
        event.preventDefault()
      }
    }
  },
  created() {
    this.setButtonAndSearch(router.currentRoute)
  }
}



// WEBPACK FOOTER //
// ./src/components/app/header/page-header/page-header.js